<template>
  <div class="main-content">
    <div class="header">
      <div class="container-fluid">
        <b-card class="mt-5" v-if="loads == true">
          <b-skeleton animation="wave" width="15%"></b-skeleton>
          <b-skeleton animation="wave" width="35%"></b-skeleton>
          <!-- <b-skeleton animation="wave" width="70%"></b-skeleton> -->
        </b-card>
        <div class="card mt-5" v-if="loads == false">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">
                  Budget Plan <small>Version {{ bodys.version }}</small>
                </h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">Manage you budget's</p>
              </div>
              <div class="col-12 col-md-auto d-flex flex-wrap-reverse">
                <button class="btn btn-outline-primary mr-2" type="button" @click="historyBack()">Cancel</button>
                <button class="btn btn-primary" type="button" v-b-modal.modal-confirm>Submit</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <b-card class="mt-5" v-if="loads == true">
            <div class="row">
              <div class="col-2">
                <b-skeleton animation="wave" width="45%"></b-skeleton>
                <b-skeleton animation="wave" width="75%"></b-skeleton>
              </div>
              <div class="col-2">
                <b-skeleton animation="wave" width="45%"></b-skeleton>
                <b-skeleton animation="wave" width="75%"></b-skeleton>
              </div>
              <div class="col-2">
                <b-skeleton animation="wave" width="45%"></b-skeleton>
                <b-skeleton animation="wave" width="75%"></b-skeleton>
              </div>
              <div class="col-2">
                <b-skeleton animation="wave" width="45%"></b-skeleton>
                <b-skeleton animation="wave" width="75%"></b-skeleton>
              </div>
              <div class="col-2">
                <b-skeleton animation="wave" width="45%"></b-skeleton>
                <b-skeleton animation="wave" width="75%"></b-skeleton>
              </div>
              <div class="col-2">
                <b-skeleton animation="wave" width="45%"></b-skeleton>
                <b-skeleton animation="wave" width="75%"></b-skeleton>
              </div>
            </div>
            <div class="mt-4 p-3 float-end">
              <b-skeleton type="button"></b-skeleton>
            </div>
            <!-- <b-skeleton animation="wave" width="70%"></b-skeleton> -->
          </b-card>
          <div class="card" v-if="loads == false">
            <div class="card-body">
              <div class="row row row-cols-1 row-cols-md-2 row-cols-xl-4 gx-5 gy-3">
                <div class="col">
                  <div class="row align-items-center mr-5">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-home"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Department</h4>
                      <small class="text-body-secondary"
                        ><span> {{ bodys.fund_center?.department_code }} - {{ bodys?.departments }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center mr-5">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-credit-card"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Fund Center</h4>
                      <small class="text-body-secondary"
                        ><span> {{ bodys.fund_center?.fund_center }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center mr-5">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-calendar"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Year</h4>
                      <small class="text-body-secondary"
                        ><span> {{ bodys.year }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center mr-5">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Total OPEX + CAPEX</h4>
                      <small class="text-body-secondary"
                        ><span>Rp. {{ convertNumber(bodys.total) }}</span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4 d-flex align-items-center">
                <div class="avatar avatar-sm flex-shrink-0 me-3">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-clipboard"></i>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <h4 class="mb-1 font-weight-bold">Budget title</h4>
                  <input type="text" class="form-control w-50" v-model="bodys.title" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <b-skeleton-table :rows="1" :columns="2" :table-props="{ bordered: true, striped: true }" v-if="loads == true" />
          <form @submit.prevent="submitAll">
            <b-tabs id="tabs" v-model="activeTab" content-class="mt-3" v-if="loads == false" pills fill>
              <b-tab :title="`OPEX (Total: Rp.${convertNumber(bodys.opex_total)})`">
                <div class="row" v-if="loadingPaste">
                  <div class="col-12">
                    <div class="text-center">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-12">
                    <div class="card shadow-none border-secondary" style="border-style: dashed; background: none">
                      <div class="card-body">
                        <label class="w-100 text-center"
                          >Paste from clipboard (spreadsheet)
                          <span
                            v-b-popover.hover.right="
                              'Please ensure your spreadsheet locale is set to English (US) or English (UK) to display currency with comma separators for thousands, like this: 1,234,567.00.'
                            "
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <input type="text" class="form-control border-info" @paste="handlePasteOpex($event)" :disabled="!bodys.fund_center_id" />
                      </div>
                    </div>
                    <div
                      class="card shadow-none border-secondary"
                      style="border-style: dashed; background: none; cursor: pointer"
                      @click.prevent="addBudget('opex')"
                    >
                      <div class="card-body">
                        <div class="d-flex text-secondary w-100" style="align-items: center; justify-content: center">Add Transaction Type</div>
                      </div>
                    </div>
                    <template>
                      <div class="accordion" role="tablist">
                        <!-- v-b-toggle="'collapse-a collapse-b'" -->
                        <div class="card" v-for="(item, i) in bodys.opex" :key="`opex_${i}`">
                          <div class="card-header">
                            <div class="d-flex w-100" v-b-toggle="`accor_opex_${i}`" style="align-items: center">
                              <h3 class="m-0">
                                <span>Transaction Type #{{ i + 1 }} (Total: Rp. {{ convertNumber(item.summary.total) }})</span>
                              </h3>
                            </div>
                            <!-- <div class=""> -->
                            <span
                              v-if="item?.opex_item.length > 0"
                              class="mr-2"
                              v-b-popover.hover.right="'Cannot Delete This Transaction type, since it already have budget item'"
                              variant="secondary"
                              style="cursor: pointer"
                            >
                              <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 22px"></i>
                            </span>
                            <button
                              class="ml-auto btn btn-danger"
                              type="button"
                              @click="removeBudget('opex', i)"
                              :disabled="item?.opex_item.length > 0"
                            >
                              <i class="fe fe-trash"></i>
                            </button>

                            <!-- </div> -->
                          </div>
                          <!-- <b-collapse :id="`accor_opex_${i}`" :accordion="`opex_collapse`"
                                                    role="tabpanel"> -->
                          <div class="card-body">
                            <div class="row">
                              <div class="col-6">
                                <div class="form-group">
                                  <label>Transaction Type</label>
                                  <!--                                                              <v-select :options="listTT.data"
                                                                        :reduce="(e) => e.id"
                                                                        v-model="item.account_id" label="account"
                                                                        @input="selectTransaction($event, i)"
                                                              />-->

                                  <v-select
                                    :options="listTT.data"
                                    :reduce="(e) => e.id"
                                    :value="item.account_id"
                                    label="account"
                                    @input="selectTransaction($event, i)"
                                    :name="`${i}_transaction_type_opex`"
                                    v-validate="'required'"
                                    data-vv-validate-on="change"
                                  />
                                  <span class="text-danger" v-show="isDuplicateErrorTransactionType(`${i}_transaction_type_opex`)">
                                    Transaction Type is Duplicate
                                  </span>
                                  <span class="text-sm text-danger" v-show="errors.has(`${i}_transaction_type_opex`)">
                                    Transaction Type is Required
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-12 text-right">
                                <button class="btn btn-success" type="button" @click="newBudgetItem(i)">Add Budget Item</button>
                              </div>
                            </div>
                            <div class="accordion" role="tablist">
                              <!-- v-b-toggle="'collapse-a collapse-b'" -->
                              <div class="card" v-for="(listBudget, index) in item.opex_item" :key="`budget_item_${index}`">
                                <div class="card-header">
                                  <div class="d-flex w-100" v-b-toggle="`budget_item_toggle_${index}`" style="align-items: center">
                                    <h3 class="m-0">
                                      <span>Budget Item #{{ index + 1 }} </span>
                                    </h3>
                                  </div>
                                  <span
                                    v-if="listBudget?.budget.length > 0"
                                    class="mr-2"
                                    v-b-popover.hover.right="'Cannot Delete This Budget Item , since it already have Budget Task'"
                                    variant="secondary"
                                    style="cursor: pointer"
                                  >
                                    <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 22px"></i>
                                  </span>
                                  <button
                                    class="btn btn-danger"
                                    type="button"
                                    @click="removeBudgetItem(i, index)"
                                    :disabled="listBudget?.budget.length > 0"
                                  >
                                    <i class="fe fe-trash"></i>
                                  </button>
                                </div>
                                <!-- <b-collapse :id="`budget_item_toggle_${index}`"
                                                                    :accordion="`budget_item_collapse`" role="tabpanel"> -->
                                <div class="row p-3">
                                  <div class="col-4">
                                    <div class="form-group">
                                      <label>TT Budget Item</label>
                                      <!--                                                                      <v-select :options="item.budget_item_list"
                                                                                :reduce="(e) => e.id" label="budget_item"
                                                                                v-model="listBudget.budget_item_id"
                                                                                @input="searchGL($event, i, index)"
                                                                      />-->
                                      <v-select
                                        :options="item.budget_item_list"
                                        :reduce="(e) => e.id"
                                        label="budget_item"
                                        :value="listBudget.budget_item_id"
                                        @input="searchGL($event, i, index)"
                                        :name="`${i}_${index}_budget_item_opex`"
                                        v-validate="'required'"
                                        data-vv-validate-on="change"
                                      />
                                      <span class="text-danger" v-show="isDuplicateErrorBudgetItemOpex(`${i}_${index}_budget_item_opex`)">
                                        TT Budget Item is Duplicate
                                      </span>
                                      <span class="text-sm text-danger" v-show="errors.has(`${i}_${index}_budget_item_opex`)">
                                        TT Budget Item is Required
                                      </span>
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="form-group">
                                      <label>GL Number</label>
                                      <!-- {{ listFundCenter }}/ -->
                                      <input type="text" class="form-control" v-model="listBudget.opex_gl.gl_code" disabled />
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="form-group">
                                      <label>Fund</label>
                                      <input type="hidden" class="form-control" v-model="listBudget.fund_id" disabled />
                                      <input type="text" class="form-control" v-model="listBudget.fund.fund" disabled />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 mt-3">
                                  <div class="d-flex justify-content-between mb-2">
                                    <input
                                      type="text"
                                      class="form-control w-50 border-info"
                                      placeholder="Paste from clipboard"
                                      :disabled="!listBudget.budget_item_id"
                                      @paste="handlePasteTaskOpex($event, i, index)"
                                    />
                                    <button class="btn btn-sm btn-success mb-3" type="button" @click="newBudgetTask(i, index)">
                                      Add Budget Task
                                    </button>
                                  </div>
                                  <div style="overflow: auto">
                                    <table class="table table-bordered" style="table-layout: fixed; word-wrap: break-word">
                                      <thead>
                                        <tr>
                                          <th style="width: 100px">Action</th>
                                          <th style="width: 300px">Budget Task</th>
                                          <th style="width: 300px">Description</th>

                                          <th style="width: 200px">Jan</th>
                                          <th style="width: 200px">Feb</th>
                                          <th style="width: 200px">Mar</th>
                                          <th style="width: 200px">Apr</th>
                                          <th style="width: 200px">May</th>
                                          <th style="width: 200px">Jun</th>
                                          <th style="width: 200px">Jul</th>
                                          <th style="width: 200px">Aug</th>
                                          <th style="width: 200px">Sep</th>
                                          <th style="width: 200px">Oct</th>
                                          <th style="width: 200px">Nov</th>
                                          <th style="width: 200px">Dec</th>
                                          <th style="width: 200px">Total</th>
                                        </tr>
                                      </thead>
                                      <tbody v-for="(item, indexBudget) in listBudget.budget" :key="`indexBudget_${indexBudget}`">
                                        <tr>
                                          <td class="text-center">
                                            <span
                                              v-if="item?.actual_budget?.length > 0 || item?.relocate?.length > 0 || item?.total > 0"
                                              class="mr-2"
                                              v-b-popover.hover.right="
                                                getHintTaskOpex(item?.actual_budget?.length, item?.relocate?.length, item?.total)
                                              "
                                              variant="secondary"
                                              style="cursor: pointer"
                                            >
                                              <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 22px"></i>
                                            </span>
                                            <i
                                              class="fe fe-x-circle text-danger"
                                              :style="{
                                                cursor: 'pointer',
                                                fontSize: '22px',
                                                opacity: item?.actual_budget?.length > 0 || item?.relocate?.length > 0 || item?.total > 0 ? 0.5 : 1,
                                              }"
                                              @click="
                                                item?.actual_budget?.length > 0 || item?.relocate?.length > 0 || item?.total > 0
                                                  ? null
                                                  : removeBudgetTaskOpex(i, index, indexBudget)
                                              "
                                            ></i>
                                          </td>
                                          <td>
                                            <input
                                              type="text"
                                              :class="`form-control ${
                                                errors.has(`${i}_${index}_${indexBudget}_budget_task_opex`) ? 'is-invalid' : ''
                                              }`"
                                              v-model="item.name"
                                              :name="`${i}_${index}_${indexBudget}_budget_task_opex`"
                                              v-validate="'required'"
                                              @input="validateDuplicateTaskOpex(i, index)"
                                            />
                                            <span class="invalid-feedback" v-show="errors.has(`${i}_${index}_${indexBudget}_budget_task_opex`)">
                                              Budget Task is Required
                                            </span>
                                            <span class="text-danger" v-show="isDuplicateErrorOpex(`${i}_${index}_${indexBudget}_budget_task_opex`)">
                                              Budget Task is Duplicate
                                            </span>
                                          </td>
                                          <td>
                                            <input type="text" class="form-control" style="border: none" v-model="item.description" />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'jan') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.jan"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'feb') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.feb"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'mar') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.mar"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'apr') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.apr"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'may') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.may"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'jun') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.jun"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'jul') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.jul"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'aug') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.aug"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'sep') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.sep"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'oct') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.oct"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'nov') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.nov"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td>
                                            <div class="text-right">
                                              <span
                                                class="text-success align-content-end w-full"
                                                v-b-popover.hover.top="
                                                  `Relocation from Internal Memo PK, this is the minimum value of this month can be edited`
                                                "
                                                style="cursor: pointer"
                                                >{{ getRelocateValue(item.code, 'dec') }}</span
                                              >
                                            </div>
                                            <vue-numeric
                                              class="form-control"
                                              style="border: none"
                                              currency="Rp. "
                                              separator=","
                                              v-model="item.dec"
                                              @blur="countSum(item, i, index, indexBudget)"
                                            />
                                          </td>
                                          <td :contenteditable="false">
                                            Rp.
                                            {{ convertNumber(item.total) }}
                                          </td>
                                        </tr>
                                      </tbody>
                                      <tbody>
                                        <tr>
                                          <td colspan="3" class="text-right">Total :</td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.jan) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.feb) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.mar) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.apr) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.may) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.jun) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.jul) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.aug) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.sep) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.oct) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.nov) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.dec) }}
                                          </td>
                                          <td>
                                            Rp.
                                            {{ convertNumber(listBudget.summary.total) }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <!-- </b-collapse> -->
                              </div>
                            </div>
                          </div>
                          <!-- </b-collapse> -->
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
              <b-tab :title="`CAPEX (Total: Rp. ${convertNumber(bodys.capex_total)})`">
                <div class="row" v-if="loadingPaste">
                  <div class="col-12">
                    <div class="text-center">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-12">
                    <div class="card shadow-none border-secondary" style="border-style: dashed; background: none">
                      <div class="card-body">
                        <label class="w-100 text-center"
                          >Paste from clipboard (spreadsheet)
                          <span
                            v-b-popover.hover.right="
                              'Please ensure your spreadsheet locale is set to English (US) or English (UK) to display currency with comma separators for thousands, like this: 1,234,567.00.'
                            "
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <input type="text" class="form-control border-info" @paste="handlePasteCapex($event)" :disabled="!bodys.fund_center_id" />
                      </div>
                    </div>
                    <div
                      class="card shadow-none border-secondary"
                      style="border-style: dashed; background: none; cursor: pointer"
                      @click.prevent="addBudget('capex')"
                    >
                      <div class="card-body">
                        <div class="d-flex text-secondary w-100" style="align-items: center; justify-content: center">Add Budget Item</div>
                      </div>
                    </div>
                    <template>
                      <div class="accordion" role="tablist">
                        <!-- v-b-toggle="'collapse-a collapse-b'" -->
                        <div class="card" v-for="(item, i) in bodys.capex" :key="`capex_${i}`">
                          <div class="card-header" v-b-toggle="`accor_capex_${i}`">
                            <div class="d-flex w-100" style="align-items: center">
                              <h3 class="m-0">
                                <span> Budget Item #{{ i + 1 }} (Total: Rp. {{ convertNumber(item.summary.total) }})</span>
                              </h3>
                              <div class="ml-auto">
                                <span
                                  v-if="item?.budget.length > 0"
                                  class="mr-2"
                                  v-b-popover.hover.right="'Cannot Delete This Budget Item , since it already have Budget Task'"
                                  variant="secondary"
                                  style="cursor: pointer"
                                >
                                  <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 23px"></i>
                                </span>
                                <button class="btn btn-danger" type="button" @click="removeBudget('capex', i)" :disabled="item?.budget.length > 0">
                                  <i class="fe fe-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- <b-collapse :id="`accor_capex_${i}`" :accordion="`capex_collapse`" role="tabpanel"> -->
                          <div class="row p-3">
                            <div class="col-4">
                              <div class="form-group">
                                <label>TT Budget Item</label>
                                <v-select
                                  :options="listCapex"
                                  :reduce="(e) => e.id"
                                  label="budget_item"
                                  :value="bodys.capex[i].capex_gl_id"
                                  @input="searchGLCapex($event, i)"
                                  :name="`${i}_budget_item_capex`"
                                  v-validate="'required'"
                                  data-vv-validate-on="change"
                                  :filterBy="
                                    (option, label, search) =>
                                      option.budget_item.toLowerCase().includes(search.toLowerCase()) ||
                                      option.fund.toLowerCase().includes(search.toLowerCase())
                                  "
                                >
                                  <template slot="option" slot-scope="option">
                                    {{ `${option?.fund} - ${option?.budget_item}` }}
                                  </template>
                                  <template slot="selected-option" slot-scope="option">
                                    {{ `${option?.fund} - ${option?.budget_item}` }}
                                  </template>
                                </v-select>
                                <span class="text-danger" v-show="isDuplicateErrorBudgetItemCapex(`${i}_budget_item_capex`)">
                                  TT Budget Item is Duplicate
                                </span>
                                <span class="text-sm text-danger" v-show="errors.has(`${i}_budget_item_capex`)"> TT Budget Item is Required </span>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="form-group">
                                <label>GL Number</label>
                                <!-- {{ listFundCenter }}/ -->
                                <input type="text" class="form-control" disabled v-model="item.capex_gl.gl_code" />
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="form-group">
                                <label>Fund</label>
                                <input type="hidden" class="form-control" v-model="item.fund_id" disabled />
                                <input type="text" class="form-control" v-model="item.fund.fund" disabled />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 mt-3 p-5">
                              <div class="d-flex justify-content-between mb-2">
                                <input
                                  type="text"
                                  class="form-control w-50 border-info"
                                  placeholder="Paste from clipboard"
                                  :disabled="!item.account_id"
                                  @paste="handlePasteTaskCapex($event, i)"
                                />
                                <button class="btn btn-sm btn-success mb-3" type="button" @click="newBudgetTaskCapex(i)">Add Budget Task</button>
                              </div>
                              <div style="overflow: auto">
                                <table class="table table-bordered" style="table-layout: fixed; word-wrap: break-word">
                                  <thead>
                                    <tr>
                                      <th style="width: 100px">Action</th>
                                      <th style="width: 300px">Budget Task</th>
                                      <th style="width: 300px">Description</th>

                                      <th style="width: 220px">Jan</th>
                                      <th style="width: 220px">Feb</th>
                                      <th style="width: 220px">Mar</th>
                                      <th style="width: 220px">Apr</th>
                                      <th style="width: 220px">May</th>
                                      <th style="width: 220px">Jun</th>
                                      <th style="width: 220px">Jul</th>
                                      <th style="width: 220px">Aug</th>
                                      <th style="width: 220px">Sep</th>
                                      <th style="width: 220px">Oct</th>
                                      <th style="width: 220px">Nov</th>
                                      <th style="width: 220px">Dec</th>
                                      <th style="width: 220px">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody v-for="(items, indexBudget) in item.budget" :key="`indexBudget_${indexBudget}`">
                                    <tr>
                                      <td class="text-center">
                                        <span
                                          v-if="items?.actual_budget?.length > 0 || items?.relocate?.length > 0 || items?.total > 0"
                                          class="mr-2"
                                          v-b-popover.hover.right="
                                            getHintTaskCapex(items?.actual_budget?.length, items?.relocate?.length, items?.total)
                                          "
                                          variant="secondary"
                                          style="cursor: pointer"
                                        >
                                          <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 23px"></i>
                                        </span>
                                        <i
                                          class="fe fe-x-circle text-danger"
                                          :style="{
                                            cursor: 'pointer',
                                            fontSize: '22px',
                                            opacity: items?.actual_budget?.length > 0 || items?.relocate?.length > 0 || items?.total > 0 ? 0.5 : 1,
                                          }"
                                          @click="
                                            items?.actual_budget?.length > 0 || items?.relocate?.length > 0 || items?.total > 0
                                              ? null
                                              : removeBudgetTaskCapex(i, indexBudget)
                                          "
                                        ></i>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          :class="`form-control ${errors.has(`${i}_${indexBudget}_budget_task_capex`) ? 'is-invalid' : ''}`"
                                          v-model="items.name"
                                          :name="`${i}_${indexBudget}_budget_task_capex`"
                                          v-validate="'required'"
                                          @input="validateDuplicateCapex(i)"
                                        />
                                        <span class="invalid-feedback" v-show="errors.has(`${i}_${indexBudget}_budget_task_capex`)">
                                          Budget Task is Required
                                        </span>
                                        <span class="text-danger" v-show="isDuplicateErrorCapex(`${i}_${indexBudget}_budget_task_capex`)">
                                          Budget Task is Duplicate
                                        </span>
                                      </td>
                                      <td>
                                        <input type="text" class="form-control" style="border: none" v-model="items.description" />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.jan"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.feb"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.mar"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.apr"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.may"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.jun"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.jul"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.aug"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.sep"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.oct"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.nov"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td>
                                        <vue-numeric
                                          class="form-control"
                                          style="border: none"
                                          currency="Rp. "
                                          separator=","
                                          v-model="items.dec"
                                          @blur="countSumCapex(items, i, indexBudget)"
                                        />
                                      </td>
                                      <td :contenteditable="false">Rp. {{ convertNumber(items.total) }}</td>
                                    </tr>
                                  </tbody>
                                  <tbody>
                                    <tr>
                                      <td colspan="3" class="text-right">Total :</td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.jan) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.feb) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.mar) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.apr) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.may) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.jun) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.jul) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.aug) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.sep) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.oct) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.nov) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.dec) }}
                                      </td>
                                      <td>
                                        Rp.
                                        {{ convertNumber(item.summary.total) }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <!-- </b-collapse> -->
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </form>
        </div>
      </div>
    </div>
    <b-modal id="modal-confirm" hide-footer title="Confirm Form">
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" v-model="bodys.notes" required></textarea>
      </div>
      <div class="float-end">
        <button class="btn btn-primary" type="button" disabled v-if="isLoading == true">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </button>
        <div v-else>
          <b-button class="mr-2" variant="primary" @click="submitAll('exist')">Save</b-button>
          <!-- <b-button variant="primary" @click="submitAll('version')"
            >Save as New Version</b-button
          > -->
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from '@/api/axios';
import Vue from 'vue';
import TreePlan from '../../components/helpers/treePlan.vue';
export default {
  components: {
    TreePlan,
  },
  computed: {
    // detail() {
    //     return
    // },
    listFundCenter() {
      return this.$store.getters['fundCenter/listData'];
    },
    listTT() {
      return this.$store.getters['ttAccount/listAccount'];
    },
    /*listFund() {
                return this.$store.getters["fund/listData"];
            },*/
    /*listCapex() {
                return this.$store.getters["capexGL/listData"];
            },*/
  },
  data() {
    return {
      activeTab: 0,
      isLoading: false,
      body: {
        notes: '',
        title: '',
        year: '',
        is_active: false,
        // description: "aaa",
        fund_center: '',
        fund_center_id: '',
        opex: [],
        capex: [],
        sum_capex: 0,
        sum_opex: 0,
      },
      bodys: {},
      ids: '',
      loads: false,
      fund_center: '',
      // body.opex: [],
      budget_capex: [],
      inputType: 'text',
      // budget_data_columns: [],
      // item: [],
      // budget: []
      listDepartement: [],
      listFund: [],
      listFundCapex: [],
      listCapex: [],
      duplicateErrorIndexes: [], // opex task
      duplicateErrorIndexesCapex: [], // capex task
      duplicateErrorIndexesTransactionType: [], // opex transaction
      duplicateErrorIndexesBudgetItemOpex: [], // opex item
      duplicateErrorIndexesBudgetItemCapex: [], // capex item
      loadingPaste: false,
    };
  },
  // watch: {
  //     fund_center: function (newValue) {
  //         const result = newValue.replace(/\D/g, "")
  //             .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //         Vue.nextTick(() => this.body.fund_center = result);
  //     }
  // },
  mounted() {
    this.getDetail();
    this.getFundCenter();
    this.getListTT();
    //this.getListFund();
    this.getListCapexGL();
  },

  methods: {
    getHintTaskOpex(budgets, relocates, totals) {
      let budget = budgets || 0;
      let relocate = relocates || 0;
      let total = totals || 0;
      let textHintOpex = '';
      if ((budget > 0 || relocate > 0) && total > 0) {
        textHintOpex = 'Cannot Delete This Budget Task, since it already have Value and other transactions';
      }
      if ((budget > 0 || relocate > 0) && total < 1) {
        textHintOpex = 'Cannot Delete This Budget Task, since it already have other transactions';
      }
      if (total > 0 && budget < 1 && relocate < 1) {
        textHintOpex = 'Cannot Delete This Budget Task, since it already have Value';
      }
      return textHintOpex;
    },
    getHintTaskCapex(budgets, relocates, totals) {
      let budget = budgets || 0;
      let relocate = relocates || 0;
      let total = totals || 0;
      let textHintCapex = '';
      if ((budget > 0 || relocate > 0) && total > 0) {
        textHintCapex = 'Cannot Delete This Budget Task, since it already have Value and other transactions';
      }
      if ((budget > 0 || relocate > 0) && total < 1) {
        textHintCapex = 'Cannot Delete This Budget Task, since it already have other transactions';
      }
      if (total > 0 && budget < 1 && relocate < 1) {
        textHintCapex = 'Cannot Delete This Budget Task, since it already have Value';
      }
      return textHintCapex;
    },
    isDuplicateErrorBudgetItemOpex(index) {
      return this.duplicateErrorIndexesBudgetItemOpex.includes(index);
    },
    isDuplicateErrorBudgetItemCapex(index) {
      return this.duplicateErrorIndexesBudgetItemCapex.includes(index);
    },
    isDuplicateErrorTransactionType(index) {
      return this.duplicateErrorIndexesTransactionType.includes(index);
    },
    isDuplicateErrorOpex(index) {
      return this.duplicateErrorIndexes.includes(index);
    },
    isDuplicateErrorCapex(index) {
      return this.duplicateErrorIndexesCapex.includes(index);
    },
    validateDuplicateTaskOpex(index, itemIndex) {
      const seen = [];
      const duplicateIndexes = [];
      const listBudget = this.bodys.opex[index]?.opex_item[itemIndex]?.budget || [];
      //clear entries for this index
      this.duplicateErrorIndexes = this.duplicateErrorIndexes.filter((item) => !item.startsWith(`${index}_${itemIndex}_`));

      for (let x = 0; x < listBudget.length; x++) {
        //push to seen only if not empty
        const trimmed = listBudget[x].name?.trim().toLowerCase();
        if (trimmed) {
          //push both duplicate indexes
          if (seen.includes(trimmed)) {
            duplicateIndexes.push(seen.indexOf(trimmed));
            duplicateIndexes.push(x);
          }
          seen.push(trimmed);
        }
      }

      for (let duplicate of duplicateIndexes) {
        this.duplicateErrorIndexes.push(`${index}_${itemIndex}_${duplicate}_budget_task_opex`);
      }
    },
    validateDuplicateBudgetItemOpex(index) {
      const seen = [];
      const duplicateIndexes = [];
      const items = this.bodys.opex[index]?.opex_item || [];
      //clear entries for this index
      this.duplicateErrorIndexesBudgetItemOpex = this.duplicateErrorIndexesBudgetItemOpex.filter((item) => !item.startsWith(`${index}_`));

      for (let x = 0; x < items.length; x++) {
        const trimmed = items[x].budget_item_id?.trim().toLowerCase();
        //push to seen only if not empty
        if (trimmed) {
          //push both duplicate indexes
          if (seen.includes(trimmed)) {
            duplicateIndexes.push(seen.indexOf(trimmed));
            duplicateIndexes.push(x);
          }
          seen.push(trimmed);
        }
      }

      for (let duplicate of duplicateIndexes) {
        this.duplicateErrorIndexesBudgetItemOpex.push(`${index}_${duplicate}_budget_item_opex`);
      }
    },
    validateDuplicateTransactionType(index) {
      const seen = [];
      const duplicateIndexes = [];
      const listTransactionType = this.bodys.opex || [];
      //clear entries for this index
      this.duplicateErrorIndexesTransactionType = [];

      for (let x = 0; x < listTransactionType.length; x++) {
        const trimmed = listTransactionType[x].account_id?.trim().toLowerCase();
        //push to seen only if not empty
        if (trimmed) {
          //push both duplicate indexes
          if (seen.includes(trimmed)) {
            duplicateIndexes.push(seen.indexOf(trimmed));
            duplicateIndexes.push(x);
          }
          seen.push(trimmed);
        }
      }

      for (let duplicate of duplicateIndexes) {
        this.duplicateErrorIndexesTransactionType.push(`${duplicate}_transaction_type_opex`);
      }
    },

    validateDuplicateCapex(index) {
      const seen = [];
      const duplicateIndexes = [];
      const listBudget = this.bodys.capex[index]?.budget || [];
      //clear entries for this index
      this.duplicateErrorIndexesCapex = this.duplicateErrorIndexesCapex.filter((item) => !item.startsWith(`${index}_`));

      for (let x = 0; x < listBudget.length; x++) {
        const trimmed = listBudget[x].name?.trim().toLowerCase();
        //push to seen only if not empty
        if (trimmed) {
          //push both duplicate indexes
          if (seen.includes(trimmed)) {
            duplicateIndexes.push(seen.indexOf(trimmed));
            duplicateIndexes.push(x);
          }
          seen.push(trimmed);
        }
      }

      for (let duplicate of duplicateIndexes) {
        this.duplicateErrorIndexesCapex.push(`${index}_${duplicate}_budget_task_capex`);
      }
    },
    validateDuplicateBudgetItemCapex(index) {
      const seen = [];
      const duplicateIndexes = [];
      const listTransactionType = this.bodys.capex || [];

      //clear entries for this index
      this.duplicateErrorIndexesBudgetItemCapex = [];

      for (let x = 0; x < listTransactionType.length; x++) {
        const trimmed = listTransactionType[x].capex_gl_id?.trim().toLowerCase();
        //push to seen only if not empty
        if (trimmed) {
          //push both duplicate indexes
          if (seen.includes(trimmed)) {
            duplicateIndexes.push(seen.indexOf(trimmed));
            duplicateIndexes.push(x);
          }
          seen.push(trimmed);
        }
      }

      for (let duplicate of duplicateIndexes) {
        this.duplicateErrorIndexesBudgetItemCapex.push(`${duplicate}_budget_item_capex`);
      }
    },

    async getDetail() {
      this.loads = true;
      const id = this.$router.currentRoute.query.id;
      this.ids = id;
      await axiosIns
        .get(`${axiosIns.defaults.baseURL}/plan/${id}`)
        .then(async (resp) => {
          let dat = resp.data.data;
          dat.year = dat.year.toString();
          if (dat.opex && dat.opex.length > 0) {
            const promises = dat.opex.map(async (opex) => {
              if (opex.account_id) {
                // const reps = await axiosIns.get(`${axiosIns.defaults.baseURL}/account/${opex.account_id}/budget-items`);
                const reps = await axiosIns.get(`${axiosIns.defaults.baseURL}/account/${opex.account_id}/budget-items/${dat.fund_center_id}`);
                opex.budget_item_list = reps.data.data;
              }
              return Promise.resolve();
            });
            await Promise.all(promises);
          }

          // Loop through CAPEX items and normalize them to prevent error
          if (dat.capex && dat.capex.length) {
            dat.capex.forEach((item) => {
              // If fund is null or an empty array, set it to a default object
              if (!item.fund || Array.isArray(item.fund)) {
                item.fund = { fund: '' };
              }
            });
          }

          // Loop through OPEX items and normalize them
          if (dat.opex && dat.opex.length) {
            dat.opex.forEach((item) => {
              if (!item.fund || Array.isArray(item.fund)) {
                item.fund = { fund: '' };
              }
              // Also normalize nested opex_item arrays
              if (item.opex_item && item.opex_item.length) {
                item.opex_item.forEach((subItem) => {
                  if (!subItem.fund || Array.isArray(subItem.fund)) {
                    subItem.fund = { fund: '' };
                  }
                });
              }
            });
          }

          // Set the data after all requests are complete
          this.bodys = dat;
          this.loads = false;
          if (this.bodys.fund_center.id) {
            const resp = await axiosIns.get(`${axiosIns.defaults.baseURL}/account/budget-items/${this.bodys.fund_center.id}`);
            //const resp = await axiosIns.get(`${axiosIns.defaults.baseURL}/account/budget-items/${this.body.fund_center_id}`);
            const uniqueData = Object.values(
              resp.data.data.reduce((acc, item) => {
                if (!acc[`${item.account.account}-${item.fund.fund}`]) {
                  acc[`${item.account.account}-${item.fund.fund}`] = item; // keep first occurrence
                }
                return acc;
              }, {})
            );
            this.listCapex = uniqueData.map((items) => ({
              id: items.id,
              account_code: items.account.code,
              fund: items.fund.fund,
              budget_item: items.account.account,
              gl_code: items.gl_code,
              account_id: items.account_id,
              fund_id: items.fund_id,
            }));
          }
          for (let i = 0; i < this.bodys.opex.length; i++) {
            for (let ii = 0; ii < this.bodys.opex[i].opex_item.length; ii++) {
              if (this.bodys.opex[i].opex_item[ii]?.opex_gl_id) {
                axiosIns.get(`${axiosIns.defaults.baseURL}/opex-gl/${this.bodys.opex[i].opex_item[ii].opex_gl_id}`).then(async (resp) => {
                  await this.getListFund(resp.data.data.budget_item_id, i, ii);
                });
              }
            }
          }
          /*if(this.bodys.opex[0]?.opex_item[0]?.opex_gl_id){
                      axiosIns.get(`${axiosIns.defaults.baseURL}/opex-gl/${this.bodys.opex[0].opex_item[0].opex_gl_id}`).then(async (resp) => {
                        await this.getListFund(resp.data.data.budget_item_id);
                      })
                    }*/
        })
        .catch((error) => {
          console.error('Error fetching detail:', error);
          this.loads = false;
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Failed to load budget plan detail',
          });
        });
    },
    searchGLByFundCapex(id, i) {
      if (id) {
        const filtered = this.listFundCapex.filter((item) => item.value === id);
        this.bodys.capex[i].capex_gl_id = filtered[0]?.gl_id;
        this.bodys.capex[i].capex_gl.gl_code = filtered[0]?.gl_code;
      }
    },
    getFundCenter() {
      this.$store.dispatch('fundCenter/GET_LIST_DATA', {
        pageNumber: 1,
        pageSize: 1000,
      });
    },
    getListTT() {
      this.$store.dispatch('ttAccount/GET_LIST_ACCOUNT', {
        pageNumber: 1,
        pageSize: 1000,
      });
    },
    /*getListFund() {
                this.$store.dispatch("fund/GET_LIST_DATA", {
                    pageNumber: 1,
                    pageSize: 1000
                });
            },*/
    async getListFund(budget_item_id, iOpex, iItem) {
      this.listFund = [];
      const response = await axiosIns.get(`/fund/list/${this.bodys.fund_center_id}/${budget_item_id}`);
      if (response.data.data.length > 0) {
        this.listFund = response.data.data.map((items) => ({
          label: items?.fund?.fund,
          value: items?.fund.id,
          gl_code: items.gl_code,
        }));
        this.bodys.opex[iOpex].opex_item[iItem].fund_id = response.data.data[0]?.fund.id;
        this.bodys.opex[iOpex].opex_item[iItem].opex_gl.gl_code = response.data.data[0].gl_code;
        this.bodys.opex[iOpex].opex_item[iItem].fund.fund = response.data.data[0]?.fund?.fund;
        //listBudget.fund.fund
      } else {
        this.bodys.opex[iOpex].opex_item[iItem].fund_id = '';
        this.bodys.opex[iOpex].opex_item[iItem].opex_gl = [];
        this.bodys.opex[iOpex].opex_item[iItem].fund.fund = '';
      }
    },
    getListCapexGL() {
      /*this.$store.dispatch("capexGL/GET_LIST_DATA", {
                    pageNumber: 1,
                    pageSize: 1000
                });*/
    },

    makeFolder: function (item) {
      Vue.set(item, 'children', []);
      this.addItem(item);
    },
    addItem: function (item) {
      item.children.push({
        name: 'new stuff',
      });
    },

    async removeBudgetTaskOpex(i, indx, indxBudget) {
      const confirmed = await this.deleteConfirmation();
      if (!confirmed) {
        return;
      }
      this.bodys.opex[i].opex_item[indx].budget.splice(indxBudget, 1);
      let list = this.bodys.opex[i].opex_item[indx];
      const ttlList = this.bodys.opex[i].opex_item[indx].budget || [];
      const totalJan = ttlList.reduce((sum, it) => sum + BigInt(it.jan ?? 0), BigInt(0));
      const totalFeb = ttlList.reduce((sum, it) => sum + BigInt(it.feb ?? 0), BigInt(0));
      const totalMar = ttlList.reduce((sum, it) => sum + BigInt(it.mar ?? 0), BigInt(0));
      const totalApr = ttlList.reduce((sum, it) => sum + BigInt(it.apr ?? 0), BigInt(0));
      const totalMay = ttlList.reduce((sum, it) => sum + BigInt(it.may ?? 0), BigInt(0));
      const totalJun = ttlList.reduce((sum, it) => sum + BigInt(it.jun ?? 0), BigInt(0));
      const totalJul = ttlList.reduce((sum, it) => sum + BigInt(it.jul ?? 0), BigInt(0));
      const totalAug = ttlList.reduce((sum, it) => sum + BigInt(it.aug ?? 0), BigInt(0));
      const totalSep = ttlList.reduce((sum, it) => sum + BigInt(it.sep ?? 0), BigInt(0));
      const totalOct = ttlList.reduce((sum, it) => sum + BigInt(it.oct ?? 0), BigInt(0));
      const totalNov = ttlList.reduce((sum, it) => sum + BigInt(it.nov ?? 0), BigInt(0));
      const totalDec = ttlList.reduce((sum, it) => sum + BigInt(it.dec ?? 0), BigInt(0));
      const totalTotal = ttlList.reduce((sum, it) => sum + BigInt(it.total ?? 0), BigInt(0));

      this.bodys.opex[i].opex_item[indx].summary.jan = parseInt(totalJan);
      this.bodys.opex[i].opex_item[indx].summary.feb = parseInt(totalFeb);
      this.bodys.opex[i].opex_item[indx].summary.mar = parseInt(totalMar);

      this.bodys.opex[i].opex_item[indx].summary.apr = parseInt(totalApr);
      this.bodys.opex[i].opex_item[indx].summary.may = parseInt(totalMay);
      this.bodys.opex[i].opex_item[indx].summary.jun = parseInt(totalJun);
      this.bodys.opex[i].opex_item[indx].summary.jul = parseInt(totalJul);
      this.bodys.opex[i].opex_item[indx].summary.aug = parseInt(totalAug);
      this.bodys.opex[i].opex_item[indx].summary.sep = parseInt(totalSep);
      this.bodys.opex[i].opex_item[indx].summary.oct = parseInt(totalOct);
      this.bodys.opex[i].opex_item[indx].summary.nov = parseInt(totalNov);
      this.bodys.opex[i].opex_item[indx].summary.dec = parseInt(totalDec);

      this.bodys.opex[i].opex_item[indx].summary.total = parseInt(totalTotal);

      // count sum per budget item
      this.bodys.opex[i].summary.total = this.bodys.opex[i].opex_item.reduce((acc, item) => acc + Number(item.summary.total), 0);

      // count sum opex
      this.bodys.opex_total = this.bodys.opex.reduce((acc, item) => acc + Number(item.summary.total), 0);

      // capex + opex
      this.bodys.total = Number(this.bodys.opex_total) + Number(this.bodys.capex_total);
      this.countSumSummary();
      this.validateDuplicateTaskOpex(i, indx);
    },
    async removeBudgetTaskCapex(i, indxBudget) {
      const confirmed = await this.deleteConfirmation();
      if (!confirmed) {
        return;
      }
      this.bodys.capex[i].budget.splice(indxBudget, 1);

      const ttlList = this.bodys.capex[i].budget || [];
      const totalJan = ttlList.reduce((sum, it) => sum + BigInt(it.jan ?? 0), BigInt(0));
      const totalFeb = ttlList.reduce((sum, it) => sum + BigInt(it.feb ?? 0), BigInt(0));
      const totalMar = ttlList.reduce((sum, it) => sum + BigInt(it.mar ?? 0), BigInt(0));
      const totalApr = ttlList.reduce((sum, it) => sum + BigInt(it.apr ?? 0), BigInt(0));
      const totalMay = ttlList.reduce((sum, it) => sum + BigInt(it.may ?? 0), BigInt(0));
      const totalJun = ttlList.reduce((sum, it) => sum + BigInt(it.jun ?? 0), BigInt(0));
      const totalJul = ttlList.reduce((sum, it) => sum + BigInt(it.jul ?? 0), BigInt(0));
      const totalAug = ttlList.reduce((sum, it) => sum + BigInt(it.aug ?? 0), BigInt(0));
      const totalSep = ttlList.reduce((sum, it) => sum + BigInt(it.sep ?? 0), BigInt(0));
      const totalOct = ttlList.reduce((sum, it) => sum + BigInt(it.oct ?? 0), BigInt(0));
      const totalNov = ttlList.reduce((sum, it) => sum + BigInt(it.nov ?? 0), BigInt(0));
      const totalDec = ttlList.reduce((sum, it) => sum + BigInt(it.dec ?? 0), BigInt(0));
      const totalTotal = ttlList.reduce((sum, it) => sum + BigInt(it.total ?? 0), BigInt(0));

      this.bodys.capex[i].summary.jan = totalJan;
      this.bodys.capex[i].summary.feb = totalFeb;
      this.bodys.capex[i].summary.mar = totalMar;

      this.bodys.capex[i].summary.apr = totalApr;
      this.bodys.capex[i].summary.may = totalMay;
      this.bodys.capex[i].summary.jun = totalJun;
      this.bodys.capex[i].summary.jul = totalJul;
      this.bodys.capex[i].summary.aug = totalAug;
      this.bodys.capex[i].summary.sep = totalSep;
      this.bodys.capex[i].summary.oct = totalOct;
      this.bodys.capex[i].summary.nov = totalNov;
      this.bodys.capex[i].summary.dec = totalDec;

      this.bodys.capex[i].summary.total = totalTotal;
      this.countSumSummary();
      this.validateDuplicateCapex(i);
    },

    getAccountByIdCapex(account_id) {
      return this.listCapex.data?.find((option) => option.account_id === account_id) || { account: '' };
    },

    addBudget(type) {
      if (type === 'opex') {
        this.bodys.opex.push({
          account_id: '',
          plan_id: '',
          budget_item_list: [],
          opex_item: [],
          account: {
            account: '',
            code: '',
            id: '',
            type: '',
          },
          summary: {
            jan: 0,
            feb: 0,
            mar: 0,
            apr: 0,
            may: 0,
            jun: 0,
            jul: 0,
            aug: 0,
            sep: 0,
            oct: 0,
            nov: 0,
            dec: 0,
            total: 0,
          },
        });
      } else if (type === 'capex') {
        this.bodys.capex.push({
          account_id: '',
          capex_gl: {
            gl_code: '',
          },
          capex_gl_id: '',
          fund_id: '',
          fund: { fund: '' },
          budget: [],
          summary: {
            jan: 0,
            feb: 0,
            mar: 0,
            apr: 0,
            may: 0,
            jun: 0,
            jul: 0,
            aug: 0,
            sep: 0,
            oct: 0,
            nov: 0,
            dec: 0,
            total: 0,
          },
        });
      }
    },
    async removeBudget(type, index) {
      const confirmed = await this.deleteConfirmation();
      if (!confirmed) {
        return;
      }
      if (type === 'opex') {
        this.bodys.opex.splice(index, 1);
        this.validateDuplicateTransactionType(index);
      } else if (type === 'capex') {
        this.bodys.capex.splice(index, 1);
        this.validateDuplicateBudgetItemCapex(index);
      }
      this.countSumSummary();
    },
    async removeBudgetItem(i, index) {
      const confirmed = await this.deleteConfirmation();
      if (!confirmed) {
        return;
      }
      this.bodys.opex[i].opex_item.splice(index, 1);
      this.countSumSummary();
      this.validateDuplicateBudgetItemOpex(i);
    },

    selectFundCenter(id) {
      axiosIns.get(`${axiosIns.defaults.baseURL}/fund-center/${id}`).then((resp) => {
        this.body.fund_center = resp.data.data.fund_center;
      });
    },
    async selectTransaction(evt, i) {
      if (!evt) {
        const confirmed = await this.deleteConfirmation();
        if (!confirmed) {
          return;
        }
      }
      this.bodys.opex[i].account_id = evt;
      if (evt) {
        this.listFund[i] = [];
        for (let ii = 0; ii < this.bodys.opex[i].opex_item.length; ii++) {
          if (this.bodys.opex[i].opex_item[ii]?.opex_gl_id) {
            this.bodys.opex[i].opex_item[ii].budget_item_id = '';
            this.bodys.opex[i].opex_item[ii].fund_id = '';
            this.bodys.opex[i].opex_item[ii].opex_gl = [];
            this.bodys.opex[i].opex_item[ii].fund.fund = '';
          }
        }
        await axiosIns.get(`${axiosIns.defaults.baseURL}/account/${evt}/budget-items/${this.bodys.fund_center.id}`).then((resp) => {
          this.bodys.opex[i].budget_item_list = resp.data.data;
        });
      } else {
        this.bodys.opex[i].budget_item_list = [];
        this.listFund[i] = [];
        for (let ii = 0; ii < this.bodys.opex[i].opex_item.length; ii++) {
          if (this.bodys.opex[i].opex_item[ii]?.opex_gl_id) {
            this.bodys.opex[i].opex_item[ii].budget_item_id = '';
            this.bodys.opex[i].opex_item[ii].fund_id = '';
            this.bodys.opex[i].opex_item[ii].opex_gl = [];
            this.bodys.opex[i].opex_item[ii].fund.fund = '';
          }
        }
      }
      setTimeout(() => {
        this.validateDuplicateTransactionType(i);
        this.$validator.validateAll();
      }, 200);
    },

    newBudgetItem(i) {
      this.bodys.opex[i].opex_item.push({
        // plan_item_opex_id:"",
        budget_item_id: '',
        fund_id: '',
        fund: { fund: '' },
        opex_gl_id: '',
        budget: [],
        opex_gl: {
          budget_item_id: '',
          fund_id: '',
          gl_code: '',
        },
        summary: {
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          oct: 0,
          nov: 0,
          dec: 0,
          total: 0,
        },
      });
    },
    newBudgetTask(i, indx) {
      this.bodys.opex[i].opex_item[indx].budget.push({
        name: '',
        description: '',
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
        total: 0,
        fund_center_id: null,
      });
    },
    newBudgetTaskCapex(i) {
      this.bodys.capex[i].budget.push({
        name: '',
        description: '',
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
        total: 0,
        fund_center_id: null,
      });
    },
    // removeBudget(index) {
    //   this.budget.splice(index, 1);
    // },

    countSum(list, i, indx, indexBudget, month) {
      const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

      let total = months.reduce((acc, month) => acc + Number(list[month]), 0);
      this.bodys.opex[i].opex_item[indx].budget[indexBudget].total = total ? total.toString() : 0;

      months.forEach((month) => {
        const relocateValue = this.getRelocateValue(list.code, month, true);
        // prevet value being edited below relocateValue
        if (relocateValue > 0 && list[month] < relocateValue) {
          list[month] = relocateValue;
        }
        if (list[month] === '') {
          list[month] = 0;
        }
      });
      // count sum per all month
      this.bodys.opex[i].opex_item[indx].summary.jan = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.jan), 0);
      this.bodys.opex[i].opex_item[indx].summary.feb = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.feb), 0);
      this.bodys.opex[i].opex_item[indx].summary.mar = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.mar), 0);
      this.bodys.opex[i].opex_item[indx].summary.apr = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.apr), 0);
      this.bodys.opex[i].opex_item[indx].summary.may = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.may), 0);
      this.bodys.opex[i].opex_item[indx].summary.jun = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.jun), 0);
      this.bodys.opex[i].opex_item[indx].summary.jul = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.jul), 0);
      this.bodys.opex[i].opex_item[indx].summary.aug = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.aug), 0);
      this.bodys.opex[i].opex_item[indx].summary.sep = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.sep), 0);
      this.bodys.opex[i].opex_item[indx].summary.oct = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.oct), 0);
      this.bodys.opex[i].opex_item[indx].summary.nov = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.nov), 0);
      this.bodys.opex[i].opex_item[indx].summary.dec = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.dec), 0);
      this.bodys.opex[i].opex_item[indx].summary.total = this.bodys.opex[i].opex_item[indx].budget.reduce((acc, item) => acc + Number(item.total), 0);

      // count sum per budget item
      /*this.bodys.opex[i].summary.total = this.bodys.opex[i].opex_item.reduce((acc, item) => acc + Number(item
                    .summary.total), 0);*/
      this.bodys.opex[i].summary.total = this.bodys.opex[i].opex_item.reduce((acc, item) => acc + Number(item.summary.total), 0);

      // count sum opex
      this.bodys.opex_total = this.bodys.opex.reduce((acc, item) => acc + Number(item.summary.total), 0);

      // capex + opex
      this.bodys.total = Number(this.bodys.opex_total) + Number(this.bodys.capex_total);
      this.countSumSummary();
    },
    countSumSummary() {
      // count sum opex
      for (let x = 0; x < this.bodys.opex.length; x++) {
        for (let y = 0; y < this.bodys.opex[x].opex_item.length; y++) {
          this.bodys.opex[x].opex_item[y].summary.total = this.bodys.opex[x].opex_item[y].budget.reduce((acc, item) => acc + Number(item.total), 0);
        }
        this.bodys.opex[x].summary.total = this.bodys.opex[x].opex_item.reduce((acc, item) => acc + Number(item.summary.total), 0);
      }
      this.bodys.opex_total = this.bodys.opex.reduce((acc, item) => acc + Number(item.summary.total), 0);
      // count sum capex
      for (let x = 0; x < this.bodys.capex.length; x++) {
        for (let y = 0; y < this.bodys.capex[x].budget.length; y++) {
          this.bodys.capex[x].summary.total = this.bodys.capex[x].budget.reduce((acc, item) => acc + Number(item.total), 0);
        }
      }
      this.bodys.capex_total = this.bodys.capex.reduce((acc, item) => acc + Number(item.summary.total), 0);

      this.bodys.total = parseInt(
        parseInt(this.bodys.opex.reduce((acc, item) => acc + Number(item.summary.total), 0)) +
          parseInt(this.bodys.capex.reduce((acc, item) => acc + Number(item.summary.total), 0))
      );
    },
    countSumCapex(list, i, indexBudget) {
      const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
      let total = months.reduce((acc, month) => acc + Number(list[month]), 0);
      this.bodys.capex[i].budget[indexBudget].total = total ? total.toString() : 0;
      months.forEach((month) => {
        if (list[month] === '') {
          list[month] = 0;
        }
      });

      // count sum per all month
      this.bodys.capex[i].summary.jan = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.jan), 0);
      this.bodys.capex[i].summary.feb = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.feb), 0);
      this.bodys.capex[i].summary.mar = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.mar), 0);
      this.bodys.capex[i].summary.apr = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.apr), 0);
      this.bodys.capex[i].summary.may = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.may), 0);
      this.bodys.capex[i].summary.jun = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.jun), 0);
      this.bodys.capex[i].summary.jul = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.jul), 0);
      this.bodys.capex[i].summary.aug = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.aug), 0);
      this.bodys.capex[i].summary.sep = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.sep), 0);
      this.bodys.capex[i].summary.oct = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.oct), 0);
      this.bodys.capex[i].summary.nov = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.nov), 0);
      this.bodys.capex[i].summary.dec = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.dec), 0);
      this.bodys.capex[i].summary.total = this.bodys.capex[i].budget.reduce((acc, item) => acc + Number(item.total), 0);

      // count sum capex
      this.bodys.capex_total = this.bodys.capex.reduce((acc, item) => acc + Number(item.summary.total), 0);

      // capex + opex
      this.bodys.total = Number(this.bodys.opex_total) + Number(this.bodys.capex_total);
      this.countSumSummary();
    },

    convertNumber(dat) {
      return dat ? dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') : '0';
    },

    /*searchGL(id, i, index) {
                axiosIns.get(`${axiosIns.defaults.baseURL}/opex-gl/${id}`).then((resp) => {
                    let glCode = resp.data.data.gl_code
                    let glId = resp.data.data.id
                    this.bodys.opex[i].opex_item[index].opex_gl_id = glId
                    this.bodys.opex[i].opex_item[index].opex_gl.gl_code = glCode
                    this.bodys.opex[i].opex_item[index].fund_id = resp.data.data.fund_id
                })
            },*/
    async searchGL(id, i, index) {
      if (!id) {
        const confirmed = await this.deleteConfirmation();
        if (!confirmed) {
          return;
        }
      }
      this.bodys.opex[i].opex_item[index].budget_item_id = id;
      if (id) {
        // await axiosIns.get(`${axiosIns.defaults.baseURL}/opex-gl/${id}`).then(async (resp) => {
        // 	// let glCode = resp.data.data.gl_code;
        // 	let glId = resp?.data?.data?.id || '';
        // 	this.bodys.opex[i].opex_item[index].opex_gl_id = glId;
        // 	if (resp?.data?.data?.budget_item_id) {
        // 		await this.getListFund(resp?.data?.data?.budget_item_id, i, index);
        // 	}
        // });
        let fundData = await Promise.all(this.bodys.opex[i].budget_item_list);
        console.log(this.bodys.opex[i]);
        let fundSelected = fundData.find((item) => parseInt(item.id) === parseInt(id));
        if (fundSelected) {
          this.bodys.opex[i].opex_item[index].fund_id = fundSelected.fund[0]?.id || null;
          this.bodys.opex[i].opex_item[index].opex_gl = fundSelected.opex_gl[0] || [];
          this.bodys.opex[i].opex_item[index].fund.fund = fundSelected.fund[0]?.fund || '';
          this.bodys.opex[i].opex_item[index].opex_gl_code = fundSelected.opex_gl[0]?.gl_code || '';
          this.bodys.opex[i].opex_item[index].opex_gl_id = fundSelected.opex_gl[0]?.id || '';
        }
      } else {
        this.listFund = [];
        this.bodys.opex[i].opex_item[index].fund_id = '';
        this.bodys.opex[i].opex_item[index].opex_gl = [];
        this.bodys.opex[i].opex_item[index].fund.fund = '';
      }
      setTimeout(() => {
        this.validateDuplicateBudgetItemOpex(i);
        this.$validator.validateAll();
      }, 200);
    },
    searchGLByFund(id, i, index) {
      if (id) {
        const filtered = this.listFund.filter((item) => item.value === id);
        this.bodys.opex[i].opex_item[index].opex_gl.gl_code = filtered[0]?.gl_code;
      }
    },

    /*searchGLCapex(id, i, listCapex) {
                let choose = listCapex.find((element) => element.account_id == id);
                this.bodys.capex[i].capex_gl_id = choose.id
                this.bodys.capex[i].capex_gl.gl_code = choose.gl_code
                this.bodys.capex[i].fund_id = choose.fund_id
                // axiosIns.get(`${axiosIns.defaults.baseURL}/capex-gl/${id}`).then((resp) => {
                // this.body.opex[i].listBudget = resp.data.data.data
                // let glCode = resp.data.data.gl_code
                // this.body.capex[i].account_id = resp.data.data.account_id
                // let glId = resp.data.data.id
                // this.body.capex[i].capex_gl_id = glId
                // this.body.capex[i].capex_gl_code = glCode
                // })
            },*/
    async searchGLCapex(id, i) {
      if (!id) {
        const confirmed = await this.deleteConfirmation();
        if (!confirmed) {
          return;
        }
      }
      console.log(this.listCapex);
      if (id) {
        const glSelected = this.listCapex.find((item) => parseInt(item.id) === parseInt(id));
        if (glSelected) {
          this.listFundCapex = [
            {
              label: glSelected.fund,
              value: glSelected.fund_id,
              gl_code: glSelected.gl_code,
              gl_id: glSelected.id,
            },
          ];
          this.bodys.capex[i].fund_id = glSelected?.fund_id;
          this.bodys.capex[i].fund.fund = glSelected?.fund;
          this.bodys.capex[i].capex_gl_id = glSelected?.id;
          this.bodys.capex[i].capex_gl.gl_code = glSelected?.gl_code;
          this.bodys.capex[i].account_id = glSelected?.account_id;
        } else {
          this.bodys.capex[i].fund_id = '';
          this.bodys.capex[i].fund.fund = '';
          this.bodys.capex[i].capex_gl_id = '';
          this.bodys.capex[i].capex_gl = {};
          this.bodys.capex[i].account_id = '';
        }
        // const filtered = this.listCapex.filter((item) => item.id === id);
        // let listCpx = [];
        // await axiosIns
        // 	.get(`${axiosIns.defaults.baseURL}/capex-gl/${id}/${this.bodys.fund_center_id}`)
        // 	.then(async (resp) => {
        // 		if (resp?.data.data) {
        // 			this.listFundCapex[i] = resp?.data.data.map((items) => ({
        // 				label: items?.fund?.fund,
        // 				value: items?.fund.id,
        // 				gl_code: items.gl_code,
        // 				gl_id: items.id,
        // 			}));
        // 			this.bodys.capex[i].fund_id = resp?.data.data[0]?.fund.id;
        // 			this.bodys.capex[i].fund.fund = resp?.data.data[0]?.fund?.fund;
        // 			this.bodys.capex[i].capex_gl_id = resp?.data.data[0]?.id;
        // 			this.bodys.capex[i].capex_gl.gl_code = resp?.data.data[0]?.gl_code;
        // 		} else {
        // 			this.bodys.capex[i].fund_id = '';
        // 			this.bodys.capex[i].fund.fund = '';
        // 			this.bodys.capex[i].capex_gl = [];
        // 			this.listFundCapex[i] = [];
        // 		}
        // 	});
      } else {
        this.bodys.capex[i].fund_id = '';
        this.bodys.capex[i].fund.fund = '';
        this.bodys.capex[i].capex_gl = {};
        this.listFundCapex[i] = [];
        this.bodys.capex[i].capex_gl_id = '';
        this.bodys.capex[i].account_id = '';
      }
      setTimeout(() => {
        this.validateDuplicateBudgetItemCapex(i);
        this.$validator.validateAll();
      }, 200);
    },

    submitAll(type) {
      const bodOpex = this.bodys?.opex;
      const bodCapex = this.bodys?.capex;
      if (
        this.duplicateErrorIndexesTransactionType.length > 0 ||
        this.duplicateErrorIndexesBudgetItemOpex.length > 0 ||
        this.duplicateErrorIndexes.length > 0
      ) {
        this.activeTab = 0;
        setTimeout(() => {
          if (this.duplicateErrorIndexesTransactionType.length > 0) {
            this.activeTab = 0;
            const transactionType = this.duplicateErrorIndexesTransactionType[0];
            const el = document.getElementsByName(transactionType)[0];
            if (el) {
              const input = el.querySelector('input') || el;
              input.focus();
            }
          }
          if (this.duplicateErrorIndexesBudgetItemOpex.length > 0) {
            this.activeTab = 0;
            const budgetItemsOpex = this.duplicateErrorIndexesBudgetItemOpex[0];
            const el = document.getElementsByName(budgetItemsOpex)[0];
            if (el) {
              const input = el.querySelector('input') || el;
              input.focus();
            }
          }
          if (this.duplicateErrorIndexes.length > 0) {
            const taskOpex = this.duplicateErrorIndexes[0];
            document.getElementsByName(taskOpex)[0].focus();
          }
        }, 500); // 2000 ms = 2 seconds
      }
      /* set focus capex */
      if (this.duplicateErrorIndexesBudgetItemCapex.length > 0 || this.duplicateErrorIndexesCapex.length > 0) {
        this.activeTab = 1;
        setTimeout(() => {
          if (this.duplicateErrorIndexesBudgetItemCapex.length > 0) {
            const itemsCapex = this.duplicateErrorIndexesBudgetItemCapex[0];
            const el = document.getElementsByName(itemsCapex)[0];
            if (el) {
              const input = el.querySelector('input') || el;
              input.focus();
            }
          }
          if (this.duplicateErrorIndexesCapex.length > 0) {
            const taskCapex = this.duplicateErrorIndexesCapex[0];
            document.getElementsByName(taskCapex)[0].focus();
          }
        }, 500); // 2000 ms = 2 seconds
      }
      bodOpex.forEach((type, index) => {
        if (!type?.account_id) {
          let transactionType = index + '_transaction_type_opex';
          const el = document.getElementsByName(transactionType)[0];
          if (el) {
            this.activeTab = 0;
            setTimeout(() => {
              const input = el.querySelector('input') || el;
              input.focus();
              return;
            }, 500);
          }
        } else {
          type?.opex_item?.forEach((itm, indexItm) => {
            if (!itm?.budget_item_id) {
              let budgetItemsOpex = index + '_' + indexItm + '_budget_item_opex';
              const el = document.getElementsByName(budgetItemsOpex)[0];
              if (el) {
                this.activeTab = 0;
                setTimeout(() => {
                  const input = el.querySelector('input') || el;
                  input.focus();
                  return;
                }, 500);
              }
            } else {
              itm?.budget?.forEach((tsk, indexItmTsk) => {
                if (!tsk?.name) {
                  let taskOpex = index + '_' + indexItm + '_' + indexItmTsk + '_budget_task_opex';
                  const el = document.getElementsByName(taskOpex)[0];
                  if (el) {
                    this.activeTab = 0;
                    setTimeout(() => {
                      const input = el.querySelector('input') || el;
                      input.focus();
                      return;
                    }, 500);
                  }
                }
              });
            }
          });
        }
      });

      bodCapex.forEach((type, index) => {
        if (!type?.account_id) {
          let transactionType = index + '_budget_item_capex';
          const el = document.getElementsByName(transactionType)[0];
          if (el) {
            this.activeTab = 1;
            console.log('transactionType capex: ', transactionType);
            setTimeout(() => {
              const input = el.querySelector('input') || el;
              input.focus();
              return;
            }, 500);
          }
        } else {
          type?.budget?.forEach((tsk, indexItmTsk) => {
            if (!tsk?.name) {
              let taskCapex = index + '_' + indexItmTsk + '_budget_task_capex';
              const el = document.getElementsByName(taskCapex)[0];
              if (el) {
                this.activeTab = 1;
                console.log('task capex: ', taskCapex);
                setTimeout(() => {
                  const input = el.querySelector('input') || el;
                  input.focus();
                  return;
                }, 500);
              }
            }
          });
        }
      });
      this.$validator.validateAll().then((success) => {
        if (
          success &&
          this.duplicateErrorIndexesTransactionType.length === 0 &&
          this.duplicateErrorIndexesBudgetItemOpex.length === 0 &&
          this.duplicateErrorIndexesBudgetItemCapex.length === 0 &&
          this.duplicateErrorIndexes.length === 0 &&
          this.duplicateErrorIndexesCapex.length === 0
        ) {
          let bod = this.bodys;

          // Validation
          if (!bod.notes) {
            this.$swal({
              icon: 'warning',
              title: 'Oops...',
              text: 'Notes cannot be empty!',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK',
            });
            return;
          }

          this.isLoading = true;

          let bodySend = {
            year: bod.year,
            title: bod.title,
            fund_center_id: bod.fund_center_id,
            is_active: bod.is_active,
            notes: bod.notes,
            opex: [],
            capex: [],
          };

          for (let i = 0; i < bod.opex.length; i++) {
            bodySend.opex.push({
              plan_id: bod.opex[i].plan_id,
              id: bod.opex[i].id,
              account_id: bod.opex[i].account_id,
              opex_item: [],
            });
            for (let y = 0; y < bod.opex[i].opex_item.length; y++) {
              bodySend.opex[i].opex_item.push({
                id: bod.opex[i].opex_item[y].id,
                plan_item_opex_id: bod.opex[i].opex_item[y].plan_item_opex_id,
                budget_item_id: bod.opex[i].opex_item[y].budget_item_id,
                fund_id: parseInt(bod.opex[i].opex_item[y].fund_id),
                opex_gl_id: bod.opex[i].opex_item[y].opex_gl_id,
                budget: bod.opex[i].opex_item[y].budget,
              });
            }
          }
          for (let i = 0; i < bod.capex.length; i++) {
            bodySend.capex.push({
              id: bod.capex[i].id,
              plan_id: bod.capex[i].plan_id,
              capex_gl_id: bod.capex[i].capex_gl_id,
              fund_id: parseInt(bod.capex[i].fund_id),
              account_id: bod.capex[i].account_id,
              budget: bod.capex[i].budget,
            });
          }
          //bod.opex[0].opex_item[0].fund_id = parseInt(bod.opex[0].opex_item[0].fund_id)
          if (type == 'exist') {
            /!* Save as Update*!/;
            //this.bodys.opex[0].opex_item[0].fund_id = parseInt(this.bodys.opex[0].opex_item[0].fund_id)
            let saveVer = {
              id: this.ids,
              body: bodySend,
            };
            this.$store
              .dispatch('budgetPlan/UPDATE_EXISTING', saveVer)
              .then((resp) => {
                this.$swal('Saved!', 'Your data has been updated', 'success');
                this.isLoading = false;
                this.$router
                  .push({
                    name: 'budget_plan',
                  })
                  .catch((err) => {
                    this.$swal('Error', `${err.response.data.error}`, 'error');
                  });
              })
              .catch((err) => {
                this.isLoading = false;
                // This will catch any error from the API call
                console.log('Error during update:', err);
                this.$swal('Error', `${err.response.data.error || 'An error occurred while updating'}`, 'error');
                this.$bvModal.hide('modal-confirm');
              });
          } else if (type == 'version') {
            /!* Save as New Version *!/;
            let saveVer = {
              id: this.ids,
              body: bodySend,
            };
            this.$store
              .dispatch('budgetPlan/UPDATE_VERSIONING', saveVer)
              .then((resp) => {
                this.$swal('Saved!', 'Your data has been updated', 'success');
                this.isLoading = false;
                this.$router
                  .push({
                    name: 'budget_plan',
                  })
                  .catch((err) => {
                    this.isLoading = false;
                    this.$swal('Error', `${err.response.data.error}`, 'error');
                  });
              })
              .catch((err) => {
                this.isLoading = false;
                // This will catch any error from the API call
                console.log('Error during update:', err);
                this.$swal('Error', `${err.response.data.error || 'An error occurred while updating'}`, 'error');
              });
          }
        } else {
          this.$bvModal.hide('modal-confirm');
        }
      });
      /*let bod = this.bodys

              // Validation
              if (!bod.notes) {
              this.$swal({
                  icon: "warning",
                  title: "Oops...",
                  text: "Notes cannot be empty!",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "OK"
              });
              return;
              }

              this.isLoading = true

              let bodySend = {
                  year: bod.year,
                  title: bod.title,
                  fund_center_id: bod.fund_center_id,
                  is_active: bod.is_active,
                  notes: bod.notes,
                  opex: [],
                  capex: []
              }

              for (let i = 0; i < bod.opex.length; i++) {
                  bodySend.opex.push({
                      plan_id: bod.opex[i].plan_id,
                      id: bod.opex[i].id,
                      account_id: bod.opex[i].account_id,
                      opex_item: []
                  })
                  for (let y = 0; y < bod.opex[i].opex_item.length; y++) {
                      bodySend.opex[i].opex_item.push({
                          id: bod.opex[i].opex_item[y].id,
                          plan_item_opex_id: bod.opex[i].opex_item[y].plan_item_opex_id,
                          budget_item_id: bod.opex[i].opex_item[y].budget_item_id,
                          fund_id: parseInt(bod.opex[i].opex_item[y].fund_id),
                          opex_gl_id: bod.opex[i].opex_item[y].opex_gl_id,
                          budget: bod.opex[i].opex_item[y].budget
                      })
                  }
              }
              for (let i = 0; i < bod.capex.length; i++) {
                  bodySend.capex.push({
                      id: bod.capex[i].id,
                      plan_id: bod.capex[i].plan_id,
                      capex_gl_id: bod.capex[i].capex_gl_id,
                      fund_id: parseInt(bod.capex[i].fund_id),
                      account_id: bod.capex[i].account_id,
                      budget: bod.capex[i].budget

                  })
              }
            //bod.opex[0].opex_item[0].fund_id = parseInt(bod.opex[0].opex_item[0].fund_id)
              if (type == 'exist') {
                  /!* Save as Update*!/
                  //this.bodys.opex[0].opex_item[0].fund_id = parseInt(this.bodys.opex[0].opex_item[0].fund_id)
                  let saveVer = {
                      id: this.ids,
                      body: bodySend
                  }
                  this.$store.dispatch("budgetPlan/UPDATE_EXISTING", saveVer).then((resp) => {
                      this.$swal("Saved!", "Your data has been updated", "success");
                      this.isLoading = false
                      this.$router.push({
                          name: "budget_plan"
                      }).catch((err) => {
                          this.isLoading = false
                          this.$swal("Error", `${err.response.data.error}`, "error");
                      });
                  }).catch((err) => {
                      this.isLoading = false;
                      // This will catch any error from the API call
                      console.log("Error during update:", err);
                      this.$swal("Error", `${err.response.data.error || "An error occurred while updating"}`, "error");
                  })

              } else if (type == 'version') {
                  /!* Save as New Version *!/
                  let saveVer = {
                      id: this.ids,
                      body: bodySend
                  }
                  this.$store.dispatch("budgetPlan/UPDATE_VERSIONING", saveVer).then((resp) => {
                      this.$swal("Saved!", "Your data has been updated", "success");
                      this.isLoading = false
                      this.$router.push({
                          name: "budget_plan"
                      }).catch((err) => {
                          this.isLoading = false
                          this.$swal("Error", `${err.response.data.error}`, "error");
                      });;
                  }).catch((err) => {
                      this.isLoading = false;
                      // This will catch any error from the API call
                      console.log("Error during update:", err);
                      this.$swal("Error", `${err.response.data.error || "An error occurred while updating"}`, "error");
                  })
              }*/
    },

    historyBack() {
      this.$router.go(-1);
    },

    toNumber(value) {
      if (value === '' || value === undefined) return 0;
      if (value.split('.')[0] === '' || value.split('.')[0] === undefined) return 0;
      let cleanedValue = value.split('.')[0].replace(/\D/g, '');
      return parseFloat(cleanedValue) || 0;
    },

    handlePasteOpex(e) {
      e.preventDefault();
      if (!this.bodys.fund_center_id) return;

      const parseTransactionType = (column) => {
        const splitColumn = column.split('-');
        if (splitColumn.length > 1) {
          return splitColumn[0].trim().toString();
        }
        return null;
      };

      const addTransactionType = async (transactionId, index) => {
        this.addBudget('opex');
        const ttAccount = this.listTT?.data?.find((item) => item.code === transactionId);
        if (!ttAccount) {
          return;
        }
        this.bodys.opex[index].account_id = ttAccount?.id;
        await this.selectTransaction(ttAccount?.id, index);
      };

      const findBudgetItem = (budgetItemCode, index) => {
        // return this.bodys.opex[index]?.budget_item_list?.find((item) => item.item === budgetItemCode);
        return this.bodys.opex[index]?.budget_item_list?.find((item) => item?.opex_gl?.[0]?.gl_code === budgetItemCode);
      };

      const addBudgetItem = async (itemId, index, itemIndex) => {
        this.bodys.opex[index].opex_item[itemIndex].budget_item_id = itemId;
        await this.searchGL(itemId, index, itemIndex);
      };

      const addBudgetTask = async (item, index, itemIndex) => {
        const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        this.newBudgetTask(index, itemIndex);
        const taskIndex = this.bodys.opex[index].opex_item[itemIndex].budget.length - 1;
        const budgetTask = this.bodys.opex[index].opex_item[itemIndex].budget[taskIndex];

        budgetTask.name = item.name;
        budgetTask.description = item.description;

        for (const month of monthList) {
          budgetTask[month] = item[month] || 0;
          await this.countSum(item, index, itemIndex, taskIndex, month);
        }
        this.validateDuplicateTaskOpex(index, itemIndex);
      };

      let text = e.clipboardData.getData('text/plain');
      text = this.sanitizeStringNewLine(text);

      this.$swal({
        title: 'Are you sure?',
        text: 'All the data will be replaced by the pasted data',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, paste it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loadingPaste = true;
          const errorOpex = [];
          try {
            this.bodys.opex = [];
            const lines = text.split('\n');
            let index = -1;
            let itemIndex = -1;
            let budgetItemValid = false;
            for (const line of lines) {
              const columns = line.split('\t');
              const firstColumn = columns[0]?.trim();
              const secondColumn = columns[1]?.trim();

              if (firstColumn) {
                const transactionId = parseTransactionType(firstColumn);
                // exit loop if capex
                if (firstColumn && firstColumn.toLowerCase() === 'capex') break;
                if (transactionId) {
                  index++;
                  itemIndex = -1;
                  await addTransactionType(transactionId, index);
                  continue;
                }
                if (parseInt(firstColumn)) {
                  const budgetItem = findBudgetItem(firstColumn, index);
                  if (budgetItem) {
                    budgetItemValid = true;
                    this.newBudgetItem(index);
                    itemIndex++;
                    await addBudgetItem(budgetItem.id, index, itemIndex);
                    continue;
                  }
                  errorOpex.push(`Budget item not found :${firstColumn} - ${columns[2]}`);
                  budgetItemValid = false;
                  continue;
                }
              }

              // if (secondColumn) {
              // 	const budgetItem = findBudgetItem(secondColumn, index);
              // 	if (budgetItem) {
              // 		this.newBudgetItem(index);
              // 		itemIndex++;
              // 		await addBudgetItem(budgetItem.id, index, itemIndex);
              // 		continue;
              // 	}
              // }
              if (budgetItemValid && columns[2]?.trim() !== '' && columns[2]?.trim() !== undefined) {
                const item = {
                  name: columns[2],
                  description: columns[3],
                  jan: this.toNumber(columns[5]) || 0,
                  feb: this.toNumber(columns[6]) || 0,
                  mar: this.toNumber(columns[7]) || 0,
                  apr: this.toNumber(columns[8]) || 0,
                  may: this.toNumber(columns[9]) || 0,
                  jun: this.toNumber(columns[10]) || 0,
                  jul: this.toNumber(columns[11]) || 0,
                  aug: this.toNumber(columns[12]) || 0,
                  sep: this.toNumber(columns[13]) || 0,
                  oct: this.toNumber(columns[14]) || 0,
                  nov: this.toNumber(columns[15]) || 0,
                  dec: this.toNumber(columns[16]) || 0,
                };
                await addBudgetTask(item, index, itemIndex);
              }
            }
            this.loadingPaste = false;
          } catch (error) {
            console.error(error);
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
            this.loadingPaste = false;
            this.body.opex = [];
          }
          if (this.bodys.opex.length < 1) {
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
            this.loadingPaste = false;
          }
          console.log('errorOpex', errorOpex);
          this.countSumSummary();
        }
      });
    },

    handlePasteCapex(e) {
      e.preventDefault();
      if (!this.bodys.fund_center_id) return;
      const plainListCapex = this.listCapex.map((item) => JSON.parse(JSON.stringify(item)));
      console.log('plainListCapex', plainListCapex);

      const findBudgetItem = (glCode, budgetItemCode) => {
        // return this.listCapex.find((item) => item.gl_code === budgetItemCode);
        return this.listCapex.find((item) => item.gl_code === glCode && item.account_code === budgetItemCode);
      };

      const addBudgetItem = async (itemId, index) => {
        this.bodys.capex[index].account_id = itemId;
        await this.searchGLCapex(itemId, index);
      };

      const addBudgetTask = async (item, index) => {
        const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        this.newBudgetTaskCapex(index);
        const taskIndex = this.bodys.capex[index].budget.length - 1;
        const budgetTask = this.bodys.capex[index].budget[taskIndex];

        budgetTask.name = item.name;
        budgetTask.description = item.description;

        for (const month of monthList) {
          budgetTask[month] = item[month] || 0;
          await this.countSumCapex(item, index, taskIndex, month);
        }
        this.validateDuplicateCapex(index);
      };

      let text = e.clipboardData.getData('text/plain');
      text = this.sanitizeStringNewLine(text);

      this.$swal({
        title: 'Are you sure?',
        text: 'All the data will be replaced by the pasted data',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, paste it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loadingPaste = true;
          const errorCapex = [];
          try {
            this.bodys.capex = [];
            const lines = text.split('\n');
            let index = -1;
            let budgetItemValid = false;
            for (const line of lines) {
              const columns = line.split('\t');
              const firstColumn = columns[0].trim();
              const secondColumn = columns[1]?.trim();
              if (parseInt(firstColumn)) {
                const budgetItem = findBudgetItem(firstColumn, secondColumn);
                if (budgetItem) {
                  index++;
                  await this.addBudget('capex');
                  await addBudgetItem(budgetItem.id, index);
                  budgetItemValid = true;
                  continue;
                }
                errorCapex.push(`Budget item not found: ${firstColumn} - ${secondColumn} - ${columns[2]}`);
                budgetItemValid = false;
                continue;
              }
              if (budgetItemValid && columns[2]?.trim() !== '' && columns[2]?.trim() !== undefined) {
                const item = {
                  name: columns[2],
                  description: columns[3],
                  jan: this.toNumber(columns[5]) || 0,
                  feb: this.toNumber(columns[6]) || 0,
                  mar: this.toNumber(columns[7]) || 0,
                  apr: this.toNumber(columns[8]) || 0,
                  may: this.toNumber(columns[9]) || 0,
                  jun: this.toNumber(columns[10]) || 0,
                  jul: this.toNumber(columns[11]) || 0,
                  aug: this.toNumber(columns[12]) || 0,
                  sep: this.toNumber(columns[13]) || 0,
                  oct: this.toNumber(columns[14]) || 0,
                  nov: this.toNumber(columns[15]) || 0,
                  dec: this.toNumber(columns[16]) || 0,
                };
                await addBudgetTask(item, index);
              }
            }
            this.loadingPaste = false;
          } catch (error) {
            console.log(error);
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
            this.loadingPaste = false;
            this.bodys.capex = [];
          }
          if (this.bodys.capex.length < 1) {
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
            this.loadingPaste = false;
          }
          console.log('errorCapex', errorCapex);
          this.countSumSummary();
        }
      });
    },

    handlePasteTaskOpex(e, index, itemIndex) {
      e.preventDefault();
      if (!this.bodys.opex[index].opex_item[itemIndex].budget_item_id) return;

      const addBudgetTask = async (item, index, itemIndex) => {
        const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        this.newBudgetTask(index, itemIndex);
        const taskIndex = this.bodys.opex[index].opex_item[itemIndex].budget.length - 1;
        const budgetTask = this.bodys.opex[index].opex_item[itemIndex].budget[taskIndex];

        budgetTask.name = item.name;
        budgetTask.description = item.description;

        for (const month of monthList) {
          budgetTask[month] = item[month] || 0;
          await this.countSum(item, index, itemIndex, taskIndex, month);
        }
        this.validateDuplicateTaskOpex(index, itemIndex);
      };

      let text = e.clipboardData.getData('text/plain');
      text = this.sanitizeStringNewLine(text);

      this.$swal({
        title: 'Are you sure?',
        text: 'All the data will be replaced by the pasted data',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, paste it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const lines = text.split('\n');
          this.bodys.opex[index].opex_item[itemIndex].budget = [];
          try {
            for (const line of lines) {
              const columns = line.split('\t');
              if (columns[0]?.trim() !== '' && columns[0]?.trim() !== undefined) {
                const item = {
                  name: columns[0],
                  description: columns[1],
                  jan: this.toNumber(columns[3]) || 0,
                  feb: this.toNumber(columns[4]) || 0,
                  mar: this.toNumber(columns[5]) || 0,
                  apr: this.toNumber(columns[6]) || 0,
                  may: this.toNumber(columns[7]) || 0,
                  jun: this.toNumber(columns[8]) || 0,
                  jul: this.toNumber(columns[9]) || 0,
                  aug: this.toNumber(columns[10]) || 0,
                  sep: this.toNumber(columns[11]) || 0,
                  oct: this.toNumber(columns[12]) || 0,
                  nov: this.toNumber(columns[13]) || 0,
                  dec: this.toNumber(columns[14]) || 0,
                };
                await addBudgetTask(item, index, itemIndex);
              }
            }
          } catch (error) {
            console.log(error);
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
          }
          if (this.bodys.opex[index].opex_item[itemIndex].budget.length < 1) {
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
          }
          this.countSumSummary();
        }
      });
    },

    handlePasteTaskCapex(e, index) {
      e.preventDefault();
      if (!this.bodys.capex[index].account_id) return;

      const addBudgetTask = async (item, index) => {
        const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        this.newBudgetTaskCapex(index);
        const taskIndex = this.bodys.capex[index].budget.length - 1;
        const budgetTask = this.bodys.capex[index].budget[taskIndex];

        budgetTask.name = item.name;
        budgetTask.description = item.description;

        for (const month of monthList) {
          budgetTask[month] = item[month] || 0;
          await this.countSumCapex(item, index, taskIndex, month);
        }
        this.validateDuplicateCapex(index);
      };

      let text = e.clipboardData.getData('text/plain');
      text = this.sanitizeStringNewLine(text);

      this.$swal({
        title: 'Are you sure?',
        text: 'All the data will be replaced by the pasted data',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, paste it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const lines = text.split('\n');
          this.bodys.capex[index].budget = [];
          try {
            for (const line of lines) {
              const columns = line.split('\t');
              if (columns[0]?.trim() !== '' && columns[0]?.trim() !== undefined) {
                const item = {
                  name: columns[0],
                  description: columns[1],
                  jan: this.toNumber(columns[3]) || 0,
                  feb: this.toNumber(columns[4]) || 0,
                  mar: this.toNumber(columns[5]) || 0,
                  apr: this.toNumber(columns[6]) || 0,
                  may: this.toNumber(columns[7]) || 0,
                  jun: this.toNumber(columns[8]) || 0,
                  jul: this.toNumber(columns[9]) || 0,
                  aug: this.toNumber(columns[10]) || 0,
                  sep: this.toNumber(columns[11]) || 0,
                  oct: this.toNumber(columns[12]) || 0,
                  nov: this.toNumber(columns[13]) || 0,
                  dec: this.toNumber(columns[14]) || 0,
                };
                await addBudgetTask(item, index);
              }
            }
          } catch (error) {
            console.log(error);
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
          }
          if (this.bodys.capex[index].budget.length < 1) {
            this.$swal({
              title: 'Error',
              text: 'Invalid data format',
              icon: 'error',
              confirmButtonColor: '#00D97E',
            });
          }
          this.countSumSummary();
        }
      });
    },

    async deleteConfirmation() {
      const response = await this.$swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this data!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
      });

      return response.isConfirmed;
    },

    sanitizeStringNewLine(text) {
      //search quoted string
      return text.replace(/"[^"]*"/g, (match) => {
        //remove quotes
        const contentWithoutQuotes = match.slice(1, -1);
        //replace \n with space so it will not threated as new line
        return contentWithoutQuotes.replace(/\n/g, ' ').replace(/\r/g, '');
      });
    },
    getRelocateValue(code, month, unformated = false) {
      const relocateValue =
        this.bodys.im_relocates
          ?.filter((item) => item.code_plan_budget === code && item.month === month)
          .reduce((acc, item) => acc + Number(item.relocate_value), 0) || 0;
      if (unformated) return relocateValue;
      return relocateValue > 0 ? `+ Rp. ${this.convertNumber(relocateValue)}` : '';
    },
  },
};
</script>

<style>
.popover {
  min-width: 300px !important;
}
.popover-body {
  color: #4e4c4c !important;
}
</style>
